import PropTypes from 'prop-types';
import React from 'react';
import ChartContainer from "./chart-container";
import LoadingIndicator from "../loading-indicator/loading-indicator";
import ChartGraph from "./chart-graph";
export var ChartInteractive = function ChartInteractive(props) {
  return React.createElement("div", {
    className: "ChartInteractive"
  }, React.createElement(ChartContainer, null, React.createElement(ChartGraph, props)), props.isLoading && React.createElement("div", {
    className: "Graph-indicator-container"
  }, React.createElement(LoadingIndicator, null)));
};
ChartInteractive.propTypes = {
  isLoading: PropTypes.bool
};
export default ChartInteractive;